import styled from "@emotion/styled";
import { Typography } from "@kaltura/ds-react-components";

export const ItemContent = styled("div")(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(1),
    width: "100%",
    padding: theme.spacing(1),
}));

export const StyledItemContent = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    width: "100%",
}));

export const StyledTopContent = styled("div")(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
}));

export const StyledTypography = styled(Typography)(({ theme }) => ({
    color: theme.kaltura.palette.tone2,
}));
